//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'WheelBet',
  props: {
    // 下注对象数据
    bet: {
      type: Object,
      required: true,
      default: () => ({
        user: {},
        items: [],
        itemsTotal: 0,
        itemsCount: 0,
        isOwn: false,
        isAnimated: false
      })
    },
    // 是否中奖
    isWon: {
      type: Boolean,
      default: false
    },
    // 主播模式
    streamerMode: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      MAX_ITEMS_IN_BET: 3
    };
  },
  computed: {
    visibleItems() {
      if (!this.bet || !this.bet.items) return [];
      return this.bet.items.slice(0, this.MAX_ITEMS_IN_BET);
    }
  },
  methods: {
    formatCurrency(val) {
      if (val === undefined || val === null) return '0.00';
      return Number(val).toFixed(2);
    },
    getAvatarUrl(user) {
      return user && user.avatar ? user.avatar : require(`@/assets/images/user/ava_none.jpg`);
    },
    getPictureColorClass(color) {
      return color ? `picture_${color}` : '';
    },
    getItemColor(extra, appId) {
      return extra || 'common';
    },
    getItemImageUrl(id, size) {
      return `/assets/items/${id}_${size}.png`;
    }
  }
};
